import type { notifyModelDeleteAsyncActionSuccessProps } from "./model-delete-async-action-success.type";

import { ONE_MINUTE_IN_SECONDS } from "@/constants/Time";
import { NotificationAsyncDeleteSuccessDescription } from "@/modules/notification/notification-async-delete";

export const notifyModelDeleteAsyncActionSuccess = ({
  notify,
  payload,
}: notifyModelDeleteAsyncActionSuccessProps) => {
  notify.success({
    key: payload.id,
    title: <NotificationAsyncDeleteSuccessDescription data={payload} />,
    duration: ONE_MINUTE_IN_SECONDS,
  });
};
